import { FC } from 'react'
import { MenuProducts } from '../../../components/Products/CustomProductsLists/MenuProducts'

import { useOpenProduct } from 'featureSliced/shared/hooks/openModals/useOpenProductModal'
import { useGetTranslatedNames } from 'featureSliced/shared/hooks/useGetTranslatedNames'

import {
  ICategory,
  IProduct,
} from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { CategoryItemContainer, CategoryItemText } from './styled'

type CategoryItemType = {
  category: ICategory
}

export const CategoryItem: FC<CategoryItemType> = ({ category }) => {
  // Hooks
  const openQRMProductModal = useOpenProduct()
  const { getCategoryName } = useGetTranslatedNames()

  const handleProductClick = (product: IProduct) => {
    openQRMProductModal(product, category?.id)
  }

  return (
    <CategoryItemContainer
      id={`container_category_${category?.id}`}
      className="list_category__container"
    >
      <CategoryItemText
        id={`category_${category?.id}`}
        className="list_category"
      >
        {getCategoryName(category)}
      </CategoryItemText>
      <MenuProducts
        products={category?.products}
        templateId={category?.id}
        onProductClick={(product: IProduct) => {
          handleProductClick(product)
        }}
      />
    </CategoryItemContainer>
  )
}
